<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/mmDgEj/tc-custom/9781641085885.jpg?1717877783841" alt="This image is the cover for the book Wolf at First Sight, Monster Dads"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Wolf at First Sight, Monster Dads
      </h1>
      <p class="bookDescription body article font2">
        <b>Special Illustrated Edition</b><br/><br/> SFPD Lieutenant Joseph Zanetti has spent years protecting his city, and from the looks of St. Connal’s Pub and its bad-boy owner, Levi Keller, the place is a hotspot for trouble and violence. Joe’s problem? Levi is delectably hot, with secrets Joe can’t wait to dig into. As a Peacekeeper for paranormals, wolf shifter Levi doesn’t need the complication of a hot cop sniffing around his pub when he’s just sent his teen son off to summer camp. He’s busy brokering a peace agreement between two warring factions. When Joe stumbles into Levi’s world, both plunge into a situation neither one of them was ready for—falling in love. <br/><br/><i>Previously released as part of theanthology Bad, Dad, and Dangerous by Dreamspinner Press, October 2020</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Rhys Ford, Emily Y Chan
      </h2>
      
      <p class="authorDescription body article">&#160;Rhys Ford is an award-winning author with several long-running LGBT+ mystery, thriller, paranormal, and urban fantasy series and is a two-time LAMBDA finalist with her Murder and Mayhem novels. She is also a 2017 Gold and Silver Medal winner in the Florida Authors and Publishers President&rsquo;s Book Awards for her novels <I>Ink and Shadows</I> and <I>Hanging the Stars</I>. She is published by Dreamspinner Press and DSP Publications.<BR />She shares the house with Harley, a gray tuxedo with a flower on her face, Badger, a disgruntled alley cat who isn&rsquo;t sure living inside is a step up the social ladder, as well as a ginger cairn terrorist named Gus. Rhys is also enslaved to the upkeep of a 1979 Pontiac Firebird and enjoys murdering make-believe people.<BR />Rhys can be found at the following locations:<BR />Blog: www.rhysford.com<BR />Facebook: www.facebook.com/rhys.ford.author<BR />Twitter: @Rhys_Ford<BR />&#160;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Dreamspinner Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2c22c9ad